module.exports = {"320811001":"清江街道","320811002":"浦楼街道","320811003":"闸口街道","320811004":"清安街道","320811100":"和平镇","320811101":"武墩镇","320811102":"盐河镇","320811200":"城南乡","320811201":"黄码乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320811.json
// module id = 826
// module chunks = 0